import { useBoolean } from 'src/hooks/use-boolean';
import RHFTextField from './rhf-text-field';
import { IconButton, InputAdornment } from '@mui/material';
import Iconify from '../iconify/iconify';

interface Props {
  name: string;
  label: string;
}

export default function RHFPasswordField({ name, label }: Props) {
  const password = useBoolean();
  return (
    <RHFTextField
      sx={{ borderColor: 'white' }}
      name={name}
      label={label}
      type={password.value ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={password.onToggle} edge="end">
              <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
